import React from "react";
import { Icon } from "@material-ui/core";
import styled from "styled-components";

import { Thumbnail, ThumbnailContainer } from "js/react/views/AddSlide/Panes/Components/ThumbnailGrid";
import { _ } from "js/vendor";

const ThumbnailBar = styled.div`
    display: flex;
    align-items: center;
    width: 100%;

    label {
        font-size: 14px;
        letter-spacing: 0px;
        color: #333;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: left;
        flex-grow: 2;
        text-transform: none;
        margin: 0px;
    }

    button {
        padding: 2px;
    }
`;

const ColorChits = styled.div`
    position: absolute;
    bottom: 10px;
    display: flex;
    justify-content: flex-start;
    padding: 0px 10px;
    width: 100%;
    gap: 4px;
`;

const ColorChit = styled.div`
    border-radius: 50%;
    width: 14px;
    height: 14px;
`;

const HiddenSlideBadge = styled.div`
    position: absolute;
    top: 8px;
    right: 8px;
    width: 30px;
    height: 30px;
    z-index: 100;
    border-radius: 50%;
    background: orangered;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
        color: white;
        font-size: 20px;
    }
`;

const ThumbnailMenuWrap = styled.div`
    position: absolute;
    top: 8px;
    right: 8px;
    border-radius: 4px;
    z-index: 1001;
`;

export const ChooseThemePaneThumbnail = React.forwardRef(function ChooseThemePaneThumbnail(
    { theme, name, onClick, onDoubleClick, onMouseEnter, onMouseLeave, showBar, menu, selected, url, backgroundColor, isDowngraded, colors, isHiddenTheme, isRollover, onCloseMenu, showMenuInThumbnail },
    ref
) {
    const menuOverlay = showMenuInThumbnail && isRollover && menu && (
        <ThumbnailMenuWrap
            onMouseDown={event => {
                event.preventDefault();
                event.stopPropagation();
            }}
            onMouseUp={event => {
                event.preventDefault();
                event.stopPropagation();
            }}
            onClick={event => event.stopPropagation()}
        >
            {React.isValidElement(menu)
                ? React.cloneElement(menu, { handleCloseMenu: onCloseMenu })
                : menu}
        </ThumbnailMenuWrap>
    );

    return (
        <ThumbnailContainer
            data-item-id={theme.id}
            onClick={onClick}
            onDoubleClick={onDoubleClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            ref={ref}
        >
            <Thumbnail
                selected={selected}
                disableSizeTransition
                url={url}
                style={{
                    background: backgroundColor,
                    border: "solid 1px #ccc",
                    boxShadow: "0px 0px 20px rgba(0,0,0,.05)",
                    ...(isDowngraded ? { opacity: 0.5, cursor: "not-allowed" } : {})
                }}
                showSpinner={false}
            >
                {menuOverlay}
                {isHiddenTheme && <HiddenSlideBadge><Icon>visibility_off</Icon></HiddenSlideBadge>}
                {theme.get("isBuiltIn") && (
                    <ColorChits>
                        {colors.map(color => <ColorChit key={_.uniqueId()} style={{ background: color }} />)}
                    </ColorChits>
                )}
            </Thumbnail>
            {showBar && (
                <ThumbnailBar>
                    <label>{name}</label>
                    {!showMenuInThumbnail && menu}
                </ThumbnailBar>
            )}
        </ThumbnailContainer>
    );
});
